/**
 * Fixes floating point addition for javascript.
 * @param a
 * @param b
 */
export function forceAdd(a: number, b: number) {
    if (!a) a = 0;
    if (!b) b = 0;

    const stringA = a.toString();
    const stringB = b.toString();
    
    const maxDecimal = (stringA.length > stringB.length ? stringA : stringB).split(".")[1];
    const decimalLength = maxDecimal ? maxDecimal.length : 0;
    const correctionFactor = Math.pow(10, decimalLength);

    return ((a * correctionFactor) + (b * correctionFactor)) / correctionFactor;
}
